import useAssignments from './useAssignments';
import useGradeSyncEvents from './useGradeSyncEvents';
import useStudents from './useStudents';
import useStudentSubmissions from './useStudentSubmissions';
import useAssignmentsAssigneeModels from './useAssignmentsAssigneeModels';

const useGradesTableData = () => {
  useStudents();
  useAssignments();
  const initialFilters = new URLSearchParams(window.location.search);
  const gradingStatus = initialFilters.get('grading_status');
  useStudentSubmissions({ forFilterData: !!gradingStatus });
  useAssignmentsAssigneeModels();
  useGradeSyncEvents();
};

export default useGradesTableData;
